import { BASE_API_URL } from "../services/baseServices";

export const fetchWithAuth = async (url, options = {}) => {
  const {
    method = "GET",
    headers = {},
    body,
    data,
    ...restOptions
  } = options;

  const finalBody = body ?? data;
  const isFormData = finalBody instanceof FormData;

  const response = await fetch(`${BASE_API_URL}${url}`, {
    method,
    headers: {
      ...(isFormData ? {} : { "Content-Type": "application/json" }),
      ...headers,
    },
    body:
      finalBody === undefined
        ? undefined
        : isFormData
        ? finalBody
        : JSON.stringify(finalBody),
    ...restOptions,
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response;
};
